import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import HeaderComponent from "../../../components/header/HeaderComponent";
import { Button, FormGroup, FormText, Modal, ModalBody, ModalHeader } from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import ItemSnoozeViewContextProvider, {
     useCloseTagModal,
     useFilteredSnoozeItemTags,
     useMenuOptions,
     useOpenTagModal,
     useOpenedTagId,
     useSearchText,
     useSetSearchText,
     useSnoozeItemTags,
     useVenueOptions,
     resetSnoozeTagInfo,
     useOnDataChangeSnoozeTag,
     useOnPublish,
     useOnItemUnsnooze,
} from "./ItemSnoozeViewContext";
import InputTextComponent from "../../../components/forms/InputTextComponent";
import { BiSearch } from "react-icons/bi";
import SnoozedListItem from "../components/SnoozedListItem";
import { calculateExpiry } from "../utils/commonSnoozeUtils";

const stateManager = require("../../../utils/state/stateManager");
const navigationPageAction = require("../../../utils/state/actions/views/navigationPage/navigationPageAction");
const translator = require("../../../utils/translator/translator");
const stringUtil = require("../../../utils/string/stringUtil");
const dateUtil = require("../../../utils/dateUtil/dateUtil");
const staffUtility = require("../../../utils/domain/staff/staffUtility");

const ItemSnoozeViewContextWrapper = ({ tags, title, menus, snoozes }) => {
     return (
          <ItemSnoozeViewContextProvider tags={tags} menus={menus} existingSnoozes={snoozes}>
               <ItemSnoozeView title={title} />
          </ItemSnoozeViewContextProvider>
     );
};

const ItemSnoozeView = ({ title }) => {
     const onPublish = useOnPublish();
     const handleCancel = function () {
          stateManager.getStore().dispatch(navigationPageAction.createAction(null));
     };

     return (
          <>
               <OpenedTagModal />
               <div className="d-flex flex-column" style={{ height: "100vh" }}>
                    <HeaderComponent title={title}>
                         <div className="d-flex flex-row gap-4">
                              <SearchBar />
                              <div className="d-flex justify-content-end gap-2">
                                   <Button className="btn-cancel" onClick={handleCancel}>
                                        {translator.getLabel("cancel")}
                                   </Button>
                                   <Button className="btn-ok" onClick={onPublish}>
                                        {translator.getLabel("publish")}
                                   </Button>
                              </div>
                         </div>
                    </HeaderComponent>

                    <div className="d-flex flex-row overflow-auto">
                         <div style={{ width: "65%", borderRight: "1px solid #00000020" }}>
                              <div className="btn-nav">{translator.getLabel("available_items")}</div>
                              <SnoozeTagsList view="unsnooze" />
                         </div>
                         <div style={{ width: "35%" }}>
                              <div className="btn-nav">{translator.getLabel("snoozed_items")}</div>
                              <SnoozeTagsList view="snooze" />
                         </div>
                    </div>
               </div>
          </>
     );
};

const mapStateToProps = (state) => {
     return {
          snoozes: state.snoozes,
          tags: state.lookupData.tags,
          menus: state.menus,
     };
};

export default connect(mapStateToProps)(ItemSnoozeViewContextWrapper);

const SnoozeTagsList = memo(({ view = "all" }) => {
     const menuOptions = useMenuOptions();
     const filteredSnoozeItemTags = useFilteredSnoozeItemTags();
     const openTagModal = useOpenTagModal();
     const onItemUnsnooze = useOnItemUnsnooze();

     const handleOnEditClick = useCallback((primaryId) => {
          openTagModal(primaryId);
     }, []);

     const handleOnUnsnoozeClick = useCallback((primaryId) => {
          onItemUnsnooze(primaryId);
     }, []);

     var components = [];

     filteredSnoozeItemTags.forEach((snoozeTag) => {
          if (view === "unsnooze" && snoozeTag.isSnoozed) return;
          if (view === "snooze" && !snoozeTag.isSnoozed) return;

          let caption = snoozeTag.primaryId;
          if (snoozeTag.isSnoozed) {
               caption =
                    snoozeTag.expiry !== "-1"
                         ? `${caption} - ${translator.getLabel("snoozed_till")}: ${dateUtil.formatDate(
                                dateUtil.convertToLocalStandard(snoozeTag.expiry),
                                "ddd, HH:mm"
                           )}`
                         : `${caption} - ${translator.getLabel("snoozed_till")}: ${translator.getLabel("manual")}`;
          }

          if (view === "unsnooze") {
               components.push(<SnoozeTagsListItem item={snoozeTag} onClick={handleOnEditClick} />);
          }
          if (view === "snooze") {
               components.push(
                    <SnoozedListItem
                         caption={caption}
                         rowData={[
                              {
                                   label: translator.getLabel("dispatch_types"),
                                   value: snoozeTag.dispatchTypes.length === 0 ? translator.getLabel("all") : snoozeTag.dispatchTypes.toString(),
                              },
                              {
                                   label: translator.getLabel("venues"),
                                   value: snoozeTag.venueCodes.length === 0 ? translator.getLabel("all") : snoozeTag.venueCodes.toString(),
                              },
                              {
                                   label: translator.getLabel("menus"),
                                   value:
                                        snoozeTag.menus.length === 0
                                             ? translator.getLabel("all")
                                             : snoozeTag.menus
                                                    .map((menu) => `${menuOptions.find((m) => m.value === menu)?.label ?? "unknown"}`)
                                                    .join(", "),
                              },
                         ]}
                         snoozePayload={snoozeTag}
                         Footer={
                              <div className="d-flex flex-row gap-2">
                                   <Button
                                        style={{
                                             background: colorOpacity("--colors-primary", 0.1),
                                             border: "none",
                                             minWidth: "7vw",
                                             fontSize: "1rem",
                                        }}
                                        className="btn-action"
                                        onClick={() => handleOnEditClick(snoozeTag.primaryId)}
                                   >
                                        {translator.getLabel("edit")}
                                   </Button>
                                   <Button
                                        className="btn-action"
                                        style={{
                                             color: "var(--colors-red)",
                                             border: "none",
                                             background: colorOpacity("--colors-red", 0.1),
                                             minWidth: "7vw",
                                             fontSize: "1rem",
                                        }}
                                        onClick={() => handleOnUnsnoozeClick(snoozeTag.primaryId)}
                                   >
                                        {translator.getLabel("unsnooze")}
                                   </Button>
                              </div>
                         }
                    />
               );
          }
     });

     return (
          <div style={{height:'85vh'}} className={`overflow-auto p-4 d-flex gap-3 ${view === "snooze" ? "flex-column align-items-start" : "flex-row flex-wrap align-items-start"}`}>
               {components}
          </div>
     );
});

const SnoozeTagsListItem = memo(({ item, onClick }) => {
     const backgroundColor = "#ffffff";
     const foregroundColor = "var(--colors-text)";

     const caption = item.primaryId;

     return (
          <div
               className="d-flex flex-column"
               style={{
                    flex: 1,
                    color: "var(--colors-text)",
                    borderRadius: "var(--button-roundness)",
                    boxShadow: "0px 0px 10px #00000010",
                    backgroundColor: "#ffffff",
                    border: "1px solid #00000060",
               }}
               onClick={() => {
                    onClick(item.primaryId);
               }}
          >
               <div
                    className="p-3"
                    style={{
                         fontSize: "1.1rem",
                         borderRadius: "var(--button-roundness)",
                         backgroundColor: backgroundColor,
                    }}
               >
                    <div style={{ color: foregroundColor, whiteSpace: "nowrap" }}>{caption}</div>
               </div>
          </div>
     );
});

const SearchBar = memo(() => {
     const setSearchText = useSetSearchText();
     const searchText = useSearchText();

     const handleOnChange = (value) => {
          setSearchText(value);
     };

     return (
          <div className="w-100">
               <InputTextComponent
                    autoComplete="off"
                    type="text"
                    placeholder={
                         <span>
                              <BiSearch /> {translator.getLabel("search_tag")}
                         </span>
                    }
                    value={searchText}
                    onValueChange={handleOnChange}
                    inputTextType="text"
               />
          </div>
     );
});

const OpenedTagModal = () => {
     const openedTagId = useOpenedTagId();
     const snoozeItemTags = useSnoozeItemTags();
     const onDataChangeSnoozeTag = useOnDataChangeSnoozeTag();

     const handleSubmit = (primaryId, object) => {
          onDataChangeSnoozeTag(primaryId, object);
     };

     if (!openedTagId) return null;
     return <OpenedTagContent openedTagId={openedTagId} snoozeItemTags={snoozeItemTags} onSubmit={handleSubmit} />;
};

const OpenedTagContent = ({ openedTagId, snoozeItemTags, onSubmit }) => {


     const expiryOptions = [
          { value: "OneHour", label: translator.getLabel("one_hour") },
          { value: "TwoHour", label: translator.getLabel("two_hours") },
          { value: "FourHour", label: translator.getLabel("four_hours") },
          { value: "Today", label: translator.getLabel("today") },
          { value: "TwoDays", label: translator.getLabel("two_days") },
          { value: "ThreeDays", label: translator.getLabel("three_days") },
          { value: "Manual", label: translator.getLabel("manual") },
     ];

     const dispatchOptions = [
          { value: "DineIn", label: translator.getLabel("dine_in") },
          { value: "Delivery", label: translator.getLabel("delivery") },
          { value: "Collection", label: translator.getLabel("collection") },
          { value: "TakeAway", label: translator.getLabel("takeaway") },
     ];

     const availabilityOptions = [
          { value: false, label: translator.getLabel("in_stock") },
          { value: true, label: translator.getLabel("out_of_stock") },
     ];

     const menuOptions = useMenuOptions();
     const venueOptions = useVenueOptions();
     const closeTagModal = useCloseTagModal();

     const [state, setState] = useState(snoozeItemTags.find((s) => s.primaryId === openedTagId));
     const checkIsDataUpdatedReverseCount = useRef(-1);

     const handleCancel = () => {
          closeTagModal();
     };
     const handleOnDone = function () {
          onSubmit(state.primaryId, state);
          closeTagModal();
     };

     const handleOnChange = (object) => {
          setState((prev) => ({
               ...prev,
               ...object,
          }));
     };

     let selectedDispatchOptions = [];
     if (!stringUtil.isStringNullOrEmpty(state.dispatchTypes)) {
          selectedDispatchOptions = state.dispatchTypes.map((v) => {
               return dispatchOptions.find((d) => d.value === v);
          });
     }

     let selectedVenueCodes = [];
     if (!stringUtil.isStringNullOrEmpty(state.venueCodes)) {
          selectedVenueCodes = state.venueCodes.map((v) => {
               return venueOptions.find((d) => d.value === v);
          });
     }

     let selectedMenus = [];
     if (!stringUtil.isStringNullOrEmpty(state.menus)) {
          selectedMenus = state.menus.map((v) => {
               return menuOptions.find((d) => d.value === v);
          });
     }

     useEffect(() => {
          if (checkIsDataUpdatedReverseCount.current === -1) {
               if (!state.isSnoozed)
                    setState((prev) => ({
                         ...prev,
                         isSnoozed: true,
                         expiryCaption: "Manual",
                         operator: staffUtility.getStaffCompleteName(staffUtility.getLoginStaff()),
                         expiry: calculateExpiry("Manual"),
                    }));
               checkIsDataUpdatedReverseCount.current += 1;
          }
     }, [state.isSnoozed]);
     return (
          <Modal isOpen={true} fade={false} size="lg">
               <ModalHeader
                    close={
                         <div className="d-flex flex-row align-items-center w-100">
                              <div className="window-title" style={{ whiteSpace: "nowrap" }}>
                                   {state.primaryId}
                              </div>
                              <div className="d-flex justify-content-end gap-2 w-100">
                                   <Button className="btn-cancel" onClick={handleCancel}>
                                        {translator.getLabel("cancel")}
                                   </Button>
                                   <Button className="btn-ok" onClick={handleOnDone}>
                                        {translator.getLabel("done")}
                                   </Button>
                              </div>
                         </div>
                    }
               ></ModalHeader>
               <ModalBody>
                    <table width="100%">
                         <tr>
                              <td width="50%">
                                   <FormGroup style={{ marginRight: "20px" }}>
                                        {translator.getLabel("availability")}
                                        <Select
                                             inputProps={{ readOnly: true }}
                                             options={availabilityOptions}
                                             value={availabilityOptions.find((e) => e.value === state.isSnoozed)}
                                             isClearable={false}
                                             isSearchable={false}
                                             onChange={(optionValue) => {
                                                  if (!optionValue.value) {
                                                       handleOnChange({
                                                            ...resetSnoozeTagInfo(),
                                                       });
                                                  } else {
                                                       handleOnChange({
                                                            isSnoozed: true,
                                                            expiryCaption: "Manual",
                                                            operator: staffUtility.getStaffCompleteName(staffUtility.getLoginStaff()),
                                                            expiry: calculateExpiry("Manual"),
                                                       });
                                                  }
                                             }}
                                        />
                                        <FormText color="muted">{translator.getLabel("choose_stock_availability")} </FormText>
                                   </FormGroup>
                              </td>

                              <td width="50%">
                                   <FormGroup>
                                        {translator.getLabel("expiry")}
                                        <Select
                                             inputProps={{ readOnly: true }}
                                             isDisabled={!state.isSnoozed}
                                             isClearable={false}
                                             isSearchable={false}
                                             value={expiryOptions.find((e) => e.value === state.expiryCaption)}
                                             options={expiryOptions}
                                             onChange={(optionValue) => {
                                                  handleOnChange({
                                                       expiryCaption: optionValue.value,
                                                       expiry: calculateExpiry(optionValue.value),
                                                  });
                                             }}
                                        />
                                        <FormText color="muted">{translator.getLabel("choose_snooze_expiry")} </FormText>
                                   </FormGroup>
                              </td>
                         </tr>
                         <tr>
                              <td width="50%">
                                   <FormGroup style={{ marginRight: "20px" }}>
                                        {translator.getLabel("dispatch_types")}
                                        <Select
                                             inputProps={{ readOnly: true }}
                                             value={selectedDispatchOptions}
                                             options={dispatchOptions}
                                             isDisabled={!state.isSnoozed}
                                             isClearable={false}
                                             isSearchable={false}
                                             isMulti={true}
                                             onChange={(optionValues) => {
                                                  handleOnChange({
                                                       dispatchTypes:
                                                            optionValues == null || optionValues.length <= 0 ? [] : optionValues.map((m) => m.value),
                                                  });
                                             }}
                                        />
                                        <FormText color="muted">{translator.getLabel("choose_dispatch_type")}</FormText>
                                   </FormGroup>
                              </td>
                              <td width="50%">
                                   <FormGroup style={{ marginRight: "5px" }}>
                                        {translator.getLabel("venues")}
                                        <Select
                                             inputProps={{ readOnly: true }}
                                             options={venueOptions}
                                             value={selectedVenueCodes}
                                             isDisabled={!state.isSnoozed}
                                             isClearable={false}
                                             isSearchable={false}
                                             isMulti={true}
                                             onChange={(optionValues) => {
                                                  handleOnChange({
                                                       venueCodes:
                                                            optionValues == null || optionValues.length <= 0 ? [] : optionValues.map((m) => m.value),
                                                  });
                                             }}
                                        />
                                        <FormText color="muted">{translator.getLabel("choose_venue")} </FormText>
                                   </FormGroup>
                              </td>
                         </tr>
                         <tr>
                              <td>
                                   <FormGroup style={{ marginRight: "20px" }}>
                                        {translator.getLabel("menus")}
                                        <Select
                                             inputProps={{ readOnly: true }}
                                             options={menuOptions}
                                             value={selectedMenus}
                                             isDisabled={!state.isSnoozed}
                                             isClearable={false}
                                             isSearchable={false}
                                             isMulti={true}
                                             onChange={(optionValues) => {
                                                  handleOnChange({
                                                       menus:
                                                            optionValues == null || optionValues.length <= 0 ? [] : optionValues.map((m) => m.value),
                                                  });
                                             }}
                                        />
                                        <FormText color="muted">{translator.getLabel("choose_menu")}</FormText>
                                   </FormGroup>
                              </td>
                         </tr>
                    </table>
               </ModalBody>
          </Modal>
     );
};

function colorOpacity(color, opacity) {
     let colorValue = color;

     if (!color.startsWith("#")) {
          const computedStyle = getComputedStyle(document.documentElement);
          colorValue = computedStyle.getPropertyValue(color);
     }

     return `rgba(${parseInt(colorValue.slice(1, 3), 16)}, ${parseInt(colorValue.slice(3, 5), 16)}, ${parseInt(
          colorValue.slice(5, 7),
          16
     )}, ${opacity})`;
}
